export function parseQuery(query) {
    var queryObj = {};
    var a = (query[0] === '?' ? query.substr(1) : query).split('&');
    for (var i = 0; i < a.length; ++i) {
        var eqPos = a[i].indexOf("=");
        if (eqPos !== -1) {
            var key = a[i].slice(0, eqPos);
            var value = a[i].slice(eqPos + 1);
            if (key !== "") {
                queryObj[decodeURIComponent(key)] = decodeURIComponent(value);
            }
        }
    }

    return queryObj;
}

export function stringifyQuery(obj) {
    var query = Object.keys(obj).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
    }).join('&')
    return query;
}